import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const priceRouteDataPreload = async (): Promise<void> => {
  await useUnitOfMeasurementsStore.getState().getUnits()
}
